import _ from 'underscore';

export const updateLocation = (router, location, updates, method = 'push') => {
  router[ method ]({
    ...location,
    ...updates
  });
};

export const updateQuery = (router, location, query, method = 'push') => {
  const stringifiedQuery = _.mapObject(
    { ...location.query, ...query },
    val => (typeof val === 'number' || typeof val === 'boolean' ? `${val}` : val)
  );

  updateLocation(router, location, { query: _.omit(stringifiedQuery, _.isEmpty) }, method);
};

export const updatePath = (router, location, pathname, method = 'push') => {
  updateLocation(router, location, { pathname }, method);
};

export const valueFromQuery = (query, key) => query && query[ key ];
export const booleanFromQuery = (query, key) => valueFromQuery(query, key) && valueFromQuery(query, key) !== 'false';

export const numberFromQuery = (query, key) => {
  if (valueFromQuery(query, key)) {
    return parseInt(valueFromQuery(query, key));
  }
};

export const arrayFromQuery = (query, key) => {
  if (query && query[ key ]) {
    const queryItem = query[ key ];
    return _.isArray(queryItem) ? queryItem : [ queryItem ];
  }
};


// WEBPACK FOOTER //
// ./src/js/util/routerUtil.js